import { render, staticRenderFns } from "./RoleInputDialog.vue?vue&type=template&id=b71ac684&scoped=true&"
import script from "./RoleInputDialog.vue?vue&type=script&lang=js&"
export * from "./RoleInputDialog.vue?vue&type=script&lang=js&"
import style0 from "./RoleInputDialog.vue?vue&type=style&index=0&id=b71ac684&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71ac684",
  null
  
)

export default component.exports